<!-- 旗舰话费 -->
<template>
  <div>

    <div class="wrap">
      <!-- 顶部警示卡 -->
      <div class="top-card">
        <div class="top-head">
          <div class="phone-ico">¥</div>
          <p>重复支付、修改金额或号码、修改支付渠道不退不补</p>
        </div>
        <div class="top-row">
          <div class="time-box">
            <div class="lbl">剩余时间</div>
            <div class="val" id="timer">{{payTimeInfo.timePayoutMin}}:{{payTimeInfo.timePayoutSec}}</div>
          </div>
          <div class="warn-box">
            <div class="b">只能充值话费</div>
            <div class="s">切勿转账</div>
          </div>
        </div>
      </div>

      <!-- 主体 -->
      <div class="main-card">
        <div class="cols">
          <!-- 左：订单 -->
          <div class="col">
            <div class="order-box">
              <span class="pill">请按订单金额完成支付</span>
              <div class="order-sub">按订单金额支付，订单金额多少就付多少</div>
              <div class="amount" id="amount" v-if="orderInfo.orderId==null">--</div>
              <div class="amount" v-else>
                {{orderInfo.amount.toFixed(2)}}
                <small>元</small>
              </div>
              <div class="name-box">
                <div class="t">机主姓名</div>
                <div class="chars" v-if="orderInfo.orderId!=null">
                  <div class="char" data-copy="*" v-for="(item, index) in orderInfo.phoneOwners" :key="index" @click="copyPhoneOwnerOne(item)">{{item}}</div>
                </div>
                <div class="name-hint">充值时如需输入姓名，请按上方姓名填写；点击单个文字可以复制。</div>
              </div>
            </div>
            <div class="phone-box" v-if="orderInfo.paykind==0">
              <div class="phone-num pending" id="phone" v-if="orderInfo.orderId==null">匹配后显示</div>
              <div class="phone-num" id="phone" v-else>{{orderInfo.phone}}</div>
              <button class="copy-btn" id="copyBtn" @click="copyPhoneNo(orderInfo.phone)">点击复制充值手机号</button>
            </div>
          </div>
          <!-- 右：二维码 -->
          <div class="col" v-if="orderInfo.paykind==1">
            <div class="qr-box">
              <h3>支付宝扫码支付</h3>
              <div class="desc">如跳转支付遇到风控，请截图二维码，打开支付宝扫一扫后从相册选择。</div>
              <div class="qr-wrap">
                <div class="qr-cover" id="qrCover" v-if="orderInfo.orderId==null">匹配成功后<br>显示二维码</div>
                <img class="qr-img" id="qr" :src="orderInfo.alipQrURL" alt="支付宝二维码" v-else>
              </div>
            </div>
          </div>
        </div>

        <!-- 规则 -->
        <ul class="rules">
          <li>必须充值<b>指定金额</b>，否则不到账，不退不补</li>
          <li>修改支付方式、修改金额、重复支付、超时支付、转账不退不补</li>
          <li>付款完成等待5-10分钟，如果不到账联系客服核实</li>
          <li>支付时间120秒，不要超时支付，否则不退不补</li>
          <li>骚扰机主，平台将进行封号处理。查单24小时内，超过时间无法查询</li>
        </ul>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="footer">
      <div class="inner">
        <button class="btn-pay" id="mainBtn" disabled v-if="orderInfo.orderId==null">
          匹配中，请耐心等待 {{payTimeInfo.timeDownNo}} 秒
        </button>
        <a class="btn-pay" style="display:flex;justify-content: center;" :href="orderInfo.alipUrl" v-if="orderInfo.orderId!=null&&orderInfo.paykind==1">打开支付宝</a>
        <button class="btn-pay" id="mainBtn" v-if="orderInfo.orderId!=null&&orderInfo.paykind==0" @click="gotoZfb(orderInfo.phone)">去支付宝充值</button>
        <!-- <a class="btn-pay" style="display:flex;justify-content: center;" href="alipays://" v-if="orderInfo.orderId!=null&&orderInfo.paykind==0">打开支付宝</a> -->
      </div>
    </div>

    <!-- 匹配中弹窗 -->
    <div class="mask" id="maskMatch" v-if="orderInfo.orderId==null">
      <div class="modal" v-if="payTimeInfo.timeDownNo>0">
        <div class="mring"><i>¥</i></div>
        <h2>匹配中，请耐心等待</h2>
        <p>正在获取订单信息，通常只需十几秒钟</p>
        <div class="msec"><span id="sec">{{payTimeInfo.timeDownNo}}</span><b>秒</b></div>
        <div class="mdots">· · ·</div>
      </div>
      <div class="modal" v-else>
        <div class="mring"><i>¥</i></div>
        <h2>失败</h2>
        <p>订单获取失败，请关闭页面或重新下单</p>
        <div class="msec"><span id="sec">OK</span><b></b></div>
        <div class="mdots">· · ·</div>
      </div>
    </div>

    <!-- 姓名弹窗 -->
    <div class="mask" v-if="payTimeInfo.timeLastSss>0&&orderInfo.orderId!=null&&dialogPhoneOwner">
      <div class="modal">
        <div class="ck">✓</div>
        <h2>请记住机主姓名</h2>
        <p>充值时如需验证姓名，请输入：</p>
        <div class="name">
          <span :class="item=='*'?'star':''" v-for="(item, index) in orderInfo.phoneOwners" :key="index">{{item}}</span>
        </div>
        <button @click="dialogPhoneOwner=false">我记下姓名了</button>
      </div>
    </div>

    <!-- 去支付宝充值 -->
    <div class="mask" v-if="dialogToZfb">
      <div class="modal">
        <div class="ck">支</div>
        <h2>手机号码已复制</h2>
        <p>请打开支付宝首页 → 手机营业厅，</p>
        <p>粘贴手机号</p>
        <div class="name">
          <span class="star">{{orderInfo.phone}}</span>
        </div>
        <p>并选择 {{orderInfo.amount.toFixed(2)}} 元充值，切勿转账</p>
        <button @click="dialogToZfb=false">我知道了</button>
      </div>
    </div>

    <!-- 支付超时 -->
    <div class="mask" v-if="payTimeInfo.timeLastSss<=0&&orderInfo.statePayd!=true&&orderInfo.csTimeoutClose==true">
      <div class="modal">
        <div class="ck">×</div>
        <h2>订单已超时</h2>
        <p style="padding-bottom:20px;">您的订单支付超时，请关闭页面或重新下单</p>
      </div>
    </div>

    <!-- 支付成功 -->
    <div class="mask" v-if="orderInfo.statePayd==true">
      <div class="modal">
        <div class="ck">¥</div>
        <h2>订单成功</h2>
        <p style="padding-bottom:20px;">系统已收到您的金额</p>
      </div>
    </div>

    <div class="toast" id="toast">已复制</div>

  </div>
</template>

<script>
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    alipInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      dialogPhoneOwner: true,
      dialogToZfb: false,
    };
  },
  computed: {},
  created() {
    //设置标题
    document.title = "收银台";
    //加载样式
    this.loadTheme();
  },
  methods: {
    // 动态导入本地 CSS 文件
    async loadTheme() {
      try {
        await import("./product_phone_balance_zfb.css");
      } catch (error) {
        //console.error("CSS err", error);
      }
    },
    // 点击复制-单个姓名
    copyPhoneOwnerOne(name) {
      if (name && name == "*") {
        return;
      }
      //复制1
      this.$parent.copySome(
        name,
        1,
        () => {},
        (err) => {
          this.$parent.copyErr();
        }
      );
      // 弹框
      var toast = document.getElementById("toast");
      toast.textContent = '已复制"' + name + '"';
      toast.classList.add("show");
      setTimeout(function () {
        toast.classList.remove("show");
      }, 1000);
    },
    // 点击复制-手机号
    copyPhoneNo(num) {
      //复制2
      this.$parent.copySome(
        num,
        2,
        () => {},
        (err) => {
          this.$parent.copyErr();
        }
      );
      // 弹框
      var toast = document.getElementById("toast");
      toast.textContent = "手机号已复制";
      toast.classList.add("show");
      setTimeout(function () {
        toast.classList.remove("show");
      }, 1000);
    },
    // 去支付宝
    gotoZfb(num) {
      //复制2
      this.$parent.copySome(
        num,
        2,
        () => {},
        (err) => {
          this.$parent.copyErr();
        }
      );
      // 弹框
      var toast = document.getElementById("toast");
      toast.textContent = "手机号已复制";
      toast.classList.add("show");
      setTimeout(function () {
        toast.classList.remove("show");
      }, 1000);
      // 打开弹窗
      this.dialogToZfb = true;
    },
  },
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>

<!-- <style src="./product_phone_balance_zfb.css" scoped></style> -->
